import { Chip, Text, useTheme } from '@shared/components';

type DifficultyType = 'easy' | 'normal' | 'hard';

const label: Record<DifficultyType, string> = {
  easy: 'ง่าย',
  normal: 'กลาง',
  hard: 'ยาก',
};

export function getDifficultyType(value: string) {
  const reversedLabel = Object.fromEntries(
    Object.entries(label).map(([key, value]) => [value, key]),
  ) as Record<string, DifficultyType>;
  return reversedLabel[value] ?? 'easy';
}

export interface DifficultyChipProps {
  type: DifficultyType;
}

export default function DifficultyChip(props: Readonly<DifficultyChipProps>) {
  const { type } = props;

  const theme = useTheme();

  const backgroundColor = {
    easy: theme.palette.success.light,
    normal: theme.palette.primary.light,
    hard: theme.palette.error.light,
  };

  return (
    <Chip
      label={<Text variant='captionSemibold'>{label[type]}</Text>}
      size='small'
      sx={{
        backgroundColor: backgroundColor[type],
      }}
    />
  );
}
